import { KeyRound, ExternalLink } from 'lucide-react';
import { GS_APP_URLS } from '@gs/config/browser';

// Console UG (Système C) — gestion des accès compagnie × module (ADR-067).
const UG_CONSOLE_URL = GS_APP_URLS.ug;

/**
 * Carte de redirection — la gestion des accès a quitté GS-Admin.
 *
 * GS-Admin n'administre plus les accès : la page Utilisateurs (Système B,
 * `ug.UserAppRoles`) a été retirée du nav et des routes d'écriture
 * (MASTER-ADMIN-RETIRE-ACCES-SYSTEME-B 2026-06-22, ADR-067 D3 « zéro double
 * administration »). Les accès se gèrent désormais dans la Console UG
 * (Système C, `ug.UserCompanyBcRoles`, modèle compagnie × module). Cette carte
 * remplace l'ancienne route `/utilisateurs` pour rediriger sans casser les
 * marque-pages existants.
 *
 * Tokens uniquement (slate/brand) + échelle typo nommée — UI_STANDARDS.md.
 */
export default function AccessMovedCard() {
  return (
    <div className="flex min-h-[60vh] items-center justify-center p-6">
      <div className="max-w-sm text-center">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-brand-50 dark:bg-brand-950/30">
          <KeyRound size={28} className="text-brand-500" />
        </div>
        <h1 className="mb-2 text-head font-semibold text-slate-800 dark:text-slate-100">
          La gestion des accès a déménagé
        </h1>
        <p className="mb-6 text-field text-slate-500 dark:text-slate-400">
          Les accès se gèrent désormais dans la{' '}
          <strong className="font-semibold text-slate-700 dark:text-slate-200">Console UG</strong>{' '}
          (modèle compagnie × module).
        </p>
        <a
          href={UG_CONSOLE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 rounded-lg bg-slate-800 hover:bg-slate-700 dark:bg-slate-600 dark:hover:bg-slate-500 px-5 py-2.5 text-field font-semibold text-white transition-colors touch-manipulation"
        >
          <ExternalLink size={16} />
          Ouvrir la Console UG
        </a>
      </div>
    </div>
  );
}
